import _ from "../../../shared/utils/lodash";
import { imageTags } from "../../../shared/constants";
/**
 * If an image object has tags, and one of them is "main",
 * move it to the front.
 * Otherwise leave the order alone.
 * Does not mutate the original array.
 * @param {IImage[]} images array of image objects to be sorted.
 * @returns {IImage[]} a sorted copy of the input images array.
 */
export default function sortMainImagesToFront(images) {
    return _.orderBy(images, [function (image) { return image.tags.includes(imageTags.main); }], ["desc"]);
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/sortMainImagesToFront.ts
// module id = wCv8
// module chunks = 2